// src/components/Sidebar.tsx — Nexus-themed nav
// Links are permission-gated: a section the session can't read isn't shown.
// (UI affordance only — every endpoint re-checks server-side.)
import { NavLink } from 'react-router-dom';
import { cn } from '../lib/utils';
import { useSession } from '../lib/useSession';
import type { RbacResource } from '@eotir/oidcbridge-shared/api-contracts';

const PRIMARY: Array<{ to: string; label: string; needs?: RbacResource }> = [
  { to: '/',            label: 'Clients',     needs: 'clients' },
  { to: '/groups',      label: 'Groups',      needs: 'clients' },
  { to: '/drift',       label: 'Drift',       needs: 'clients' },
  { to: '/changelog',   label: 'Changelog',   needs: 'changelog' },
  { to: '/audit',       label: 'Audit log',   needs: 'changelog' },
  { to: '/permissions', label: 'Permissions', needs: 'permissions' },
  { to: '/account',     label: 'Account' },
];

export function Sidebar() {
  const { can } = useSession();
  const links = PRIMARY.filter((l) => !l.needs || can(l.needs, 'R'));

  return (
    <nav className="w-52 border-r border-line bg-bg-1 px-3 py-5">
      <div className="font-mono text-[9.5px] tracking-eyebrow uppercase text-ink-4 pl-3.5 mb-2.5">
        ◆ Navigate
      </div>
      <ul className="space-y-1">
        {links.map((l) => (
          <li key={l.to}>
            <NavLink
              to={l.to}
              end={l.to === '/'}
              className={({ isActive }) =>
                cn('eo-nav-link', isActive && 'active')
              }
            >
              {l.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
